import getEnv from '@/env';
import { v4 as uuidv4 } from 'uuid';
import { getCookie, setCookie } from '../cookieUtils';

export enum SplitFeatureFlag {
  SMB_PHONE_NUMBER_MANDATORY_AB_TEST = 'smb_phone_number_mandatory_ab_test',
  SMB_PHONE_NUMBER_KILL_SWITCH = 'MONARCH-473_smb_phone_number_kill_switch',
  OTTERS_3792_ENABLE_LEASESTARTDATE_FILTER_INPROGRESS = 'otters-3792_enable_leasestartdate_filter_inprogress',
  OTTERS_3986_SELF_SERVICE_USER_MANAGEMENT_ENABLED = 'otters-3986_self_service_user_management_enabled',
  OTTERS_4445_DYNAMIC_COVERAGES_CLD = 'OTTERS-4445_dynamic_coverages_cld',
  OTTERS_4472_DYNAMIC_COVERAGES_INVITE = 'OTTERS-4472_dynamic_coverages_invite',
  OTTERS_4521_APP_TRACKER_NEW_TABLE = 'OTTERS-4521_app_tracker_new_table',
  OTTERS_4527_APP_TRACKER_NEW_FILTER_UI = 'OTTERS-4527_app_tracker_new_filter_ui',
  MONARCHS_252_ENABLE_V2_SIDE_MENU_DESIGN = 'monarchs-252-enable-v2-side-menu-design',
  MONARCH_303_NEW_ENROLLMENT_CONFIRMATION_PAGE_AB_TEST = 'monarch-303-new-enrollment-confirmation-page-ab-test',
  MONARCH_319_NEW_COVERAGES_ON_LANDLORD_INVITE = 'MONARCH-319_new_coverages_on_landlord_invite',
  MONARCH_319_KILL_SWITCH_NEW_COVERAGES_ON_RENTER_INVITE = 'MONARCH-319_kill_switch_new_coverages_on_landlord_invite',
  MONARCH_446_SWAP_BUILDINGS_TO_PROPERTY_API = 'MONARCH-446_swap_buildings_to_property_api',
  MONARCH_460_NEW_RENTER_INVITE_IN_DRAWER = 'MONARCH-460_new_invite_in_drawer',
  REN_10732_INFINITE_WATCH_SCRIPT = 'REN-10732_infinite_watch_script', // on since 11/2025
  DOG_34_CENTRAL_CLAIMS_DB = 'DOG-34_central_claims_db',
  DOG_96_NEW_EVITION_COPY = 'DOG-96_new_eviction_copy',
}

export const COOKIE_KEY = 'split_anonymous_id';

export const getSplitAnonymousId = (): string => {
  let id = getCookie(COOKIE_KEY);
  if (!id) {
    id = uuidv4();
    setCookie(COOKIE_KEY, id, 365);
  }
  return id;
};

export const splitConfig = {
  core: {
    authorizationKey: getEnv().split_io_api_key || '',
    key: getSplitAnonymousId(),
  },
};
